export enum HerdControlTabs {
  ANIMAL_CATEGORY,
  ENTRIES_AND_EXITS,
  CONCILIATION,
  ARROBA_BALANCE,
}
